import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Title from "../../Title/Title";
import { fileURL, useFetch, usePOST } from "../../../ApiS";
import { Bounce, toast, ToastContainer } from "react-toastify";
import PasswordInput from "../../Inputs/Passwordinput";
import AddImage from "../../../ApiS/AddImage/AddImage";
import { useEffect, useRef, useState } from "react";
import Loader from "../../Loader";
import { AxiosError } from "axios";

interface Employee {
  id: string | number;
  first_name: string;
  last_name: string;
  father_name: string;
  mother_name: string;
  birth_place: string;
  birth_date: string;
  id_front_side_image: string;
  id_back_side_image: string;
  admin_decision_date: string;
  admin_decision_number: string;
  password: string;
  national_id: string;
  place_of_registration: string;
}
interface Error {
  id?: string[];
  first_name?: string[];
  last_name?: string[];
  father_name?: string[];
  mother_name?: string[];
  birth_place?: string[];
  birth_date?: string[];
  id_front_side_image?: string[];
  id_back_side_image?: string[];
  admin_decision_date?: string[];
  admin_decision_number?: string[];
  password?: string[];
  national_id?: string[];
  place_of_registration?: string[];
}
interface EmployeesData {
  data: Employee;
}

const Create_Account_Emp: React.FC = () => {
  const [errors, setErrors] = useState<Error>({});

  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const navigate = useNavigate();
  const { id } = useParams();
  const enabled = id ? true : false;
  const { data, isLoading } = useFetch(
    `admin/employees/${id}`,
    `admin/employees/${id}`,
    enabled
  );
  let dataOld = data?.data;

  const {
    mutation,
    handleChangeInput,
    handleSubmit,
    setFormData,
    formData,
    viewFile,
    setViewFile,
  } = usePOST(
    {
      _method: id ? "PUT" : "post",
    },
    () => {
      navigate("/regesteredemployees");
    },

    (error) => onError(error)
  );
  // console.log(formData);
  const [image_1, setImage_1] = useState<any>(dataOld?.id_front_side_image);
  const [image_2, setImage_2] = useState<any>(dataOld?.id_back_side_image);

  useEffect(()=>{
    if (dataOld?.id_front_side_image) {
      setImage_1(dataOld?.id_front_side_image)
    }
  },[dataOld?.id_front_side_image])

  useEffect(()=>{
    if (dataOld?.id_back_side_image) {
      setImage_2(dataOld?.id_back_side_image)
    }
  },[dataOld?.id_back_side_image])

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: id ? "هناك خطأ في عملية التعديل" : "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  return isLoading ? (
    <Loader />
  ) : (
    <>
    <ToastContainer position="bottom-left" />
      <Row>
        <Col lg={4} md={4}>
          <Title
            title={id ? "تعديل حسابات الموظفين" : "أنشاء حسابات الموظفين"}
          />
        </Col>
      </Row>
      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="name"
            name="first_name"
            onChange={handleChangeInput}
            title="الأسم الأول"
            placeholder="أدخل الأسم الأول"
            className="!w-full"
            defaultValue={dataOld?.first_name}
          />{" "}
        </Col>
        {errors?.first_name &&
          errors?.first_name.map((error, index) => (
            <p key={index} className="text-red-600 text-sm" dir="auto">
              {error}
            </p>
          ))}
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="last_name"
            onChange={handleChangeInput}
            title="الأسم الأخير"
            placeholder="أدخل الأسم الأخير"
            className="!w-full"
            defaultValue={dataOld?.last_name}
          />{" "}
          {errors?.last_name &&
            errors?.last_name.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="father_name"
            onChange={handleChangeInput}
            title="اسم الأب"
            placeholder="ادخل أسم الأب"
            className="!w-full"
            defaultValue={dataOld?.father_name}
          />{" "}
          {errors?.father_name &&
            errors?.father_name.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="mother_name"
            onChange={handleChangeInput}
            title="اسم الأم"
            placeholder="ادخل أسم الأم"
            className="!w-full"
            defaultValue={dataOld?.mother_name}
          />{" "}
          {errors?.mother_name &&
            errors?.mother_name.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="date"
            name="birth_date"
            onChange={handleChangeInput}
            title="تاريخ الميلاد"
            placeholder="ادخل تاريخ الميلاد"
            className="!w-full"
            defaultValue={dataOld?.birth_date}
          />{" "}
          {errors?.birth_date &&
            errors?.birth_date.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="birth_place"
            onChange={handleChangeInput}
            title="مكان الميلاد"
            placeholder="ادخل مكان الميلاد"
            className="!w-full"
            defaultValue={dataOld?.birth_place}
          />{" "}
          {errors?.birth_place &&
            errors?.birth_place.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="national_id"
            onChange={handleChangeInput}
            title="الرقم الوطني"
            placeholder="ادخل الرقم الوطني"
            className="!w-full"
            defaultValue={dataOld?.national_id}
          />{" "}
          {errors?.national_id &&
            errors?.national_id.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="place_of_registration"
            onChange={handleChangeInput}
            title="مكان القيد"
            placeholder="ادخل مكان القيد"
            className="!w-full"
            defaultValue={dataOld?.place_of_registration}
          />{" "}
          {errors?.place_of_registration &&
            errors?.place_of_registration.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="date"
            name="admin_decision_date"
            onChange={handleChangeInput}
            title="تاريخ قرار الإدارة"
            placeholder="ادخل  تاريخ قرار الإدارة"
            className="!w-full"
            defaultValue={dataOld?.admin_decision_date}
          />{" "}
          {errors?.admin_decision_date &&
            errors?.admin_decision_date.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="admin_decision_number"
            onChange={handleChangeInput}
            title="رقم قرار الإدارة"
            placeholder="ادخل  رقم قرار الإدارة"
            className="!w-full"
            defaultValue={dataOld?.admin_decision_number}
          />{" "}
          {errors?.admin_decision_number &&
            errors?.admin_decision_number.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        <Col lg={5} md={5} sm={11}>
          <h1 className="mb-4 text-lg text-Dark font-bold">
            أضف صورة الوجه الامامي للهوية الشخصية
          </h1>

          <AddImage
            type="IMAGE"
            id="id_front_side_image"
            title="أضف صورة الوجه الامامي للهوية الشخصية"
            name="id_front_side_image"
            onChange={(event) =>
              handleChangeInput(event, "id_front_side_image")
            }
            oldImage={image_1}
            newImage={viewFile["id_front_side_image"]?.image}
            clickDeleteImage={() => {
              setViewFile((prev) => ({
                ...prev,
                id_front_side_image: { image: "" },
              }));
              setFormData((prev) => ({
                ...prev,
                id_front_side_image: "",
              }));
            }}
            clickDeleteOldImage={() => {
              setImage_1(null);
            }}
          />
          {errors?.id_front_side_image &&
            errors?.id_front_side_image.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <h1 className="mb-4 text-lg text-Dark font-bold">
            أضف صورة الوجه الخلفي للهوية الشخصية
          </h1>
          <AddImage
            type="IMAGE"
            id="id_back_side_image"
            title="أضف صورة الوجه الخلفي للهوية الشخصية"
            name="id_back_side_image"
            onChange={(event) => handleChangeInput(event, "id_back_side_image")}
            oldImage={image_2}
            newImage={viewFile["id_back_side_image"]?.image}
            clickDeleteImage={() => {
              setViewFile((prev) => ({
                ...prev,
                id_back_side_image: { image: "" },
              }));
              setFormData((prev) => ({
                ...prev,
                id_back_side_image: "",
              }));
            }}
            clickDeleteOldImage={() => {
              setImage_2(null);
            }}
          />
          {errors?.id_back_side_image &&
            errors?.id_back_side_image.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        {/* <Col lg={11} md={11} sm={11} className="flex justify-around">
       

          <div className="text-end text-l flex items-center justify-start gap-2">
            <input type="checkbox" className="relative w-5 h-5" />
            <span className="text-base font-bold "> امكانية اضافة </span>
          </div>

          <div className="text-end text-l flex items-center justify-start gap-2 mt-2">
            <input type="checkbox" className="relative w-5 h-5" />
            <span className="text-base font-bold"> امكانية حذف </span>
          </div>

          <div className="text-end text-l flex items-center justify-start gap-2 mt-2">
            <input type="checkbox" className="relative w-5 h-5" />
            <span className="text-base font-bold"> امكانية تعديل </span>
          </div>
        </Col> */}
      </Row>
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
      >
        <MainButton
          onClick={() =>
            handleSubmit(id ? `admin/employees/${id}` : "admin/employees")
          }
          titlebtn={id ?  "تعديل" : "إنشاء"}
          className="w-[400px] "
        />
      </Col>
    </>
  );
};

export default Create_Account_Emp;
